import {
  App, Button, Card, Form, Input, Typography,
} from 'antd';
import { fetchMyOrganizations } from 'api/organizations';
import Layout from 'components/Layout';
import { AdminContext } from 'constants/contexts';
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router';
import http, { getHttpErrorMessage } from 'utils/http';
import { captureException } from 'utils/errors';
import { WL_CONFIG } from 'constants';
import { getData } from '../../utils';

const Logo = WL_CONFIG.logo.medium;

function Login() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { message } = App.useApp();
  const {
    isLoggedIn, organization, setOrganization, setUser,
  } = useContext(AdminContext);
  // Set by withGuard when an unauthenticated user opens a deep link, e.g. an order from a notification.
  const redirectTo = location.state?.from || { pathname: '/console' };
  const handleSubmit = (data) => {
    setLoading(true);
    http.post('user/login/super-user/', data, {
      headers: {
        Authorization: '',
      },
    })
      .then((res) => {
        const authToken = getData(res)?.key;
        if (authToken) {
          setUser({ ...res.data, authToken });
          http.get('user/rest-auth/user/', {
            headers: {
              Authorization: `Token ${authToken}`,
            },
          }).then((res) => {
            fetchMyOrganizations().then((data) => {
              if (!organization && data.results?.length) {
                setOrganization(data.results[0]);
              }
              navigate(redirectTo, { replace: true });
              setLoading(false);
              setUser({ ...res.data, authToken });
            }).catch((e) => {
              captureException(e);
              message.error(getHttpErrorMessage(e));
              setLoading(false);
            });
          }).catch((e) => {
            captureException(e);
            message.error(getHttpErrorMessage(e));
            setLoading(false);
          });
        } else {
          setLoading(false);
          message.error('Invalid login response. Check that the backend is running and the API URL is correct.');
        }
      })
      .catch((e) => {
        captureException(e);
        setLoading(false);
        message.error(getHttpErrorMessage(e));
      });
  };

  if (isLoggedIn) {
    navigate(redirectTo, { replace: true });
  }

  return (
    <Layout hasSidebar={false}>
      <div className="w-screen h-screen flex items-center justify-center">
        <Card className="w-96">
          <div className="flex items-center justify-center mb-5">
            <Logo style={{ width: '100%' }} />
          </div>
          <Typography.Title level={1} className="mt-3" style={{ fontSize: 24 }}>
            Sign in to your account
          </Typography.Title>
          <Form
            onFinish={handleSubmit}
            className="mt-6"
            validateTrigger="onSubmit"
          >
            <Form.Item
              name="email"
              rules={[{ required: true, message: 'Please input your email!' }]}
            >
              <Input placeholder="email" />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Please input your password!' }]}
            >
              <Input.Password placeholder="password" />
            </Form.Item>
            <Link to="/forget-password">Forgot your password?</Link>
            <Form.Item>
              <Button
                block
                loading={loading}
                disabled={loading}
                type="primary"
                htmlType="submit"
                className="mt-5"
              >
                Sign in
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </Layout>
  );
}

export default Login;
